import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    alert('Thank you for your message! We will get back to you shortly.');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="bg-white py-20" data-id="element-19">
      <div className="max-w-7xl mx-auto px-4" data-id="element-20">
        <div className="text-center mb-12" data-id="element-21">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-22">
            Get In Touch
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-23">
            Have questions? We're here to help. Contact us today.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-24">
          {/* Left - Contact Info & Form */}
          <div data-id="element-25">
            <div className="space-y-6 mb-8" data-id="element-26">
              <div className="flex items-start space-x-4" data-id="element-27">
                <div className="flex-shrink-0 w-12 h-12 bg-[#E63946] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-28">
                  <PhoneIcon className="h-6 w-6 text-[#E63946]" data-id="element-29" />
                </div>
                <div data-id="element-30">
                  <h3 className="font-bold text-[#0B1F3A] mb-1" data-id="element-31">Phone</h3>
                  <a href="tel:2405653357" className="text-gray-600 hover:text-[#E63946] transition-colors block" data-id="element-32">
                    240-565-3357 (Primary)
                  </a>
                  <a href="tel:3014300712" className="text-gray-600 hover:text-[#E63946] transition-colors block" data-id="element-33">
                    301-430-0712
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-34">
                <div className="flex-shrink-0 w-12 h-12 bg-[#E63946] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-35">
                  <MailIcon className="h-6 w-6 text-[#E63946]" data-id="element-36" />
                </div>
                <div data-id="element-37">
                  <h3 className="font-bold text-[#0B1F3A] mb-1" data-id="element-38">Email</h3>
                  <a href="mailto:judahnursingservices@gmail.com" className="text-gray-600 hover:text-[#E63946] transition-colors break-all" data-id="element-39">
                    judahnursingservices@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-40">
                <div className="flex-shrink-0 w-12 h-12 bg-[#E63946] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-41">
                  <MapPinIcon className="h-6 w-6 text-[#E63946]" data-id="element-42" />
                </div>
                <div data-id="element-43">
                  <h3 className="font-bold text-[#0B1F3A] mb-1" data-id="element-44">Address</h3>
                  <p className="text-gray-600" data-id="element-45">Upper Marlboro, MD</p>
                </div>
              </div>
            </div>

            <div className="flex space-x-4 mb-8" data-id="element-46">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-[#0B1F3A] rounded-full flex items-center justify-center text-white hover:bg-[#E63946] transition-colors" aria-label="Facebook" data-id="element-47">
                <FacebookIcon className="h-6 w-6" data-id="element-48" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-[#0B1F3A] rounded-full flex items-center justify-center text-white hover:bg-[#E63946] transition-colors" aria-label="Instagram" data-id="element-49">
                <InstagramIcon className="h-6 w-6" data-id="element-50" />
              </a>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-51">
              <Input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required data-id="element-52" />
              <Input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required data-id="element-53" />
              <Input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required data-id="element-54" />
              <Textarea name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} rows={5} required data-id="element-55" />
              <Button type="submit" variant="primary" className="w-full" size="lg" data-id="element-56">
                Send Message
              </Button>
            </form>
          </div>

          {/* Right - Map Placeholder */}
          <div className="bg-gray-200 rounded-lg h-[600px] flex items-center justify-center" data-id="element-57">
            <div className="text-center" data-id="element-58">
              <MapPinIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" data-id="element-59" />
              <p className="text-gray-500 font-semibold" data-id="element-60">Map Placeholder</p>
              <p className="text-gray-400 text-sm mt-2" data-id="element-61">
                Upper Marlboro, MD Service Area
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}